import api from "utils/axiosInstance";
import URL from "./apiURL";


export async function postEffortDetails(payload) {
  try {
    const res = await api.post(URL.postEffortDetails, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Error posting the effort details:", error);
    throw error;
  }
}
